import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { fuseAnimations } from '@fuse/animations';
import * as catalogo from '../catalogo';
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import {TranslateService} from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { ProgramacionN35Service} from 'app/main/wizard-n35encuestador/services/programacionn35.service';

@Component({
  selector: 'correos',
  templateUrl: './correos.component.html',
  styleUrls: ['./correos.component.scss'],
  animations   : fuseAnimations
})
export class CorreosComponent implements OnInit {

  comunicacionEditor: any;
  comunicacionEditor2: any;
  @Input() actualizaEmail: Observable<any>;
  @Output() cambiaPaso: EventEmitter<number> = new EventEmitter();
  @Output() enviaDatosEditor: EventEmitter<any> = new EventEmitter();
  @Input() actualizaTemplateGuardadosNorm: Observable<any>;

  tipoCorreos = catalogo.tipoCorreos;
  // Datos certificar vigente
  productoActual: any;

  instituto: number;
  claveNativo: string;
  idiomas: any[] = [];
  recordatoriosN35: any;

  tiposCorreos:any[] = [
    {tipo: 1}, //invitacon
    {tipo: 2}, //recordatorio
    {tipo: 3},  //aviso 1
    {tipo: 4},  //aviso 2
    {tipo: 5},  //cierre
    {tipo: 6},  //personalizados aún no inician
    {tipo: 7},  //personalizados inican pero aún no acaban
  ];

  brokersConAvisos = [1, 2, 11, 14, 18];  // correo aviso 1 y aviso 2

  constructor(
    private programacionService: ProgramacionService,
    private wizardService: WizardService,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private programacionServiceN35: ProgramacionN35Service,
  ) {
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
   }

  ngOnInit() {
    this.getInstituto();
    this.obtieneProductoActual();
    this.comunicacionEditor = this.actualizaEmail.subscribe( (datos) => {
      console.log("se envio datos desde componente editor: ",datos);
      this.checkCorreosGuardados();
    });

    this.comunicacionEditor2 = this.actualizaTemplateGuardadosNorm.subscribe( (datos) => {
      console.log("se envio datos desde componente editor: ",datos);
      // this.getStatusTemplate();
      // this.obtieneIdiomasGuardados();
      this.getFechaLanzamiento35();
    });
  }

  obtieneProductoActual(){
    /// obtiene el producto certificar vigente
    this.programacionService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      // let productos:backInter.prodCert[] = data.productosCertificar;
      console.log(data);

      let productos: any[] = [];
      switch (localStorage.getItem('tipoProducto')) {
        case '1': case 'c1': case 'c3': case 'p1': case 'm7': case 'f1': case "am1": case "td1": case "pe1":
          productos = data.productosCertificar;
        break;
        case "5": case "NOM35V3":
          productos = data.productosNorma35;
        break;
      }
      var BreakException = {};
      try {
        if (localStorage.getItem('tipoProducto')=='5'|| localStorage.getItem('tipoProducto')=='NOM35V3') {
          productos.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            if(fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')){
              this.productoActual = producto;
              throw BreakException;
            }
          });
        }
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      this.getFechaLanzamiento35();
      this.obtieneIdiomasGuardados();

    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getFechaLanzamiento35(){
      this.programacionServiceN35.getDateLanNormv2(this.productoActual.idNorma35).subscribe((response:any) => {
          if(response.success ){
            console.log(response);
            console.log('this.tipoCorreos',JSON.parse(JSON.stringify(this.tipoCorreos)));
            this.recordatoriosN35=response.programacion.recordatoriosN35;
            console.log('this.recordatoriosN35',this.recordatoriosN35);
            let tiposDefault=[1,6,7];
            this.tipoCorreos.forEach((tipo) => {
              if (!tiposDefault.includes(tipo.tipo)) {
                tipo.activo=false;
              }
            });

        this.recordatoriosN35.forEach(tipoCorreoBack => {
        let indexCorreo= this.tipoCorreos.findIndex(item => item.tipo == tipoCorreoBack.tipoAviso);
        if (indexCorreo!=-1) {
          this.tipoCorreos[indexCorreo].activo=true;
        }else{
          this.tipoCorreos[indexCorreo].activo=false;
        }
        });
        }
      }, error => {
        console.log(error);
      });
  }
  obtieneIdiomasGuardados(){
    this.idiomas = [{_id: '6218f7cd2e1b1f27dd938c99', tipoIdioma: '1', nombreIdioma: 'es', idProducto: '6218f75f2e1b1f27dd938635', vivoIdioma: 1}];
      this.checkCorreosGuardados();
    // });
  }

  getInstituto(){
    switch(this.wizardService.getInstituto()){
      case '1': case 'MX': this.instituto = 1; break;
      case '2': case 'CAyC': this.instituto = 2; break;
      case '3': case 'HK': this.instituto = 3; break;
      case '4': case 'SGP': this.instituto = 4; break;
      case '5': case 'TK': this.instituto = 5; break;
      case '6': case 'FL': this.instituto = 6; break;
      case '11': case 'BR': this.instituto = 11; break;
      case '14': case 'GCTI': this.instituto = 14; break;
      case '15': case 'ES': this.instituto = 15; break;
      case '18': case 'AMCO': this.instituto = 18; break;
    }
    if(!this.brokersConAvisos.includes(this.instituto)){  //si el instituto actual no se encuentra en la lista de brokers con avisos, se borran los avisos de la lista
      this.tiposCorreos.splice(1,2);  //comienza en pos 1, elimina 2
      this.tipoCorreos[0].activo = false;
    }
  }

  checkCorreosGuardados(){
    let idProducto = 0;
    switch (localStorage.getItem('tipoProducto')) {
      case '1':
      idProducto=1;
      break;
      case 'c1':
      idProducto=20;
      break;
      case 'c3':
      idProducto=40;
      break;
      case 'p1':
      idProducto=42;
      break;
      case 'm7':
      idProducto=41;
      break;
      case 'f1':
      idProducto=43;
      break;
      case "am1":
      idProducto=56;
      break;
      case "td1":
      idProducto=57;
      break;
      case "pe1":
      idProducto=58;
      break;
      case "NOM35V3":
      idProducto=63;
      break;

    }

    this.tiposCorreos.forEach((tipoCorreo, i) => {
      let arrIdiomas:any[] = [];
      this.idiomas.forEach(idioma => {
        if(idioma.tipoIdioma != "3"){
          let objIdiomas:any = {};
          objIdiomas.idioma = idioma.nombreIdioma;
          objIdiomas.guardado = false;
          objIdiomas.html = '';
          objIdiomas.asunto = '';
          objIdiomas.piloto = '';
          arrIdiomas.push(objIdiomas);
        }
      });
      tipoCorreo.idiomas = arrIdiomas;
      // this.getTemplateGuardado(tipoCorreo, idProducto, i);
    });
    this.getTemplateEmailEmpres();
    console.log("tiposCorreos:",this.tiposCorreos);

  }

  getTemplateEmailEmpres(){
    this.programacionServiceN35.getTemplatesNorma35(localStorage.getItem('productoID')).subscribe( (data: any) => {
      console.log('***************************',data);
      if (data.generalCorreos.length>0) {
        data.generalCorreos.forEach(correo => {
          let tipo=this.tiposCorreos.find(item=>item.tipo== correo.tipo);
          if (tipo!=undefined) {
            let idiomaCorreo= tipo.idiomas.find(item=>item.idioma== correo.idioma)
            if (idiomaCorreo!=undefined) {
              idiomaCorreo.asunto= correo.asunto;
              idiomaCorreo.guardado= true;
              idiomaCorreo.html= correo.correo;
              idiomaCorreo.idioma= correo.idioma;
              idiomaCorreo.piloto= correo.piloto;
            }
          }

        });

      }else{
        let tipoCorreosGuardar:any[]=[1,6,7];
        let datos={productoId: this.productoActual.idNorma35,tipos:tipoCorreosGuardar};
        this.programacionServiceN35.saveTemplatesNorma35(datos).subscribe((respuesta:any) => {
          console.log('respuesta de que se guardaron los correos',respuesta);
          this.getTemplateEmailEmpres();
        });

      }


      });
    }

  irPaso(numPaso: number, tipoCorreo?: number){

    console.log("Num paso" +numPaso);
    console.log("Tipo "+tipoCorreo);
    console.log("this.instituto==14 "+this.instituto);
    if (tipoCorreo==3 && this.instituto==14|| tipoCorreo==4 && this.instituto==14||tipoCorreo==5 && this.instituto==14) {
      let text = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.NOT_MESS_COM';
      let rspSi = 'MODALES.ACCIONES.aceptar';
      this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
      this.translateSrv.get(text).subscribe((res: string) => { text = res; });
      console.log("es correo de cierre de institutogcti");
      Swal.fire({
        title: text,
        icon: 'warning',
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });

    }else{
      this.cambiaPaso.emit(numPaso);
      if(tipoCorreo){
        this.enviaDatos(tipoCorreo);
      }

    }
  }

  enviaDatos(tipo:number){
    let indice = this.tiposCorreos.findIndex(item => item.tipo == tipo);
    this.enviaDatosEditor.emit(this.tiposCorreos[indice]);
  }

}
